module.exports = __webpack_public_path__ + "img/checkMark.01967446.svg";